/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementAction,
  AgreementActionOptional,
  AgreementActionMetaI,
  AgreementActionTrackedI,
} from "./agreement-action";
import {
  AgreementActionTracked,
  AgreementActionMeta,
} from "./agreement-action";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";

/**
 *
 * @export
 * @interface PersonAgreeActionDTO
 */
export interface PersonAgreeActionDTOOptional {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreeActionDTO
   */
  agreementId?: AgreementRefOptional;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreeActionDTO
   */
  agreementAction?: AgreementAction;
}

export interface PersonAgreeActionDTO extends PersonAgreeActionDTOOptional {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreeActionDTO
   */
  agreementId?: AgreementRef;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreeActionDTO
   */
  agreementAction?: AgreementAction;
}

export interface PersonAgreeActionDTOTrackedI {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreeActionDTO
   */
  agreementId?: AgreementRefTrackedI;
  agreementIdIsSet: boolean;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreeActionDTO
   */
  agreementAction?: AgreementAction;
  agreementActionIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreeActionDTO",
  function (model: PersonAgreeActionDTO) {
    const transformDatesagreementId = transformDatesMap.get("AgreementRef");
    if (transformDatesagreementId && model.agreementId) {
      transformDatesagreementId(model.agreementId);
    }
  },
);

export type PersonAgreeActionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  agreementId: PropertyMeta<AgreementRefMetaI>;
  //isDate: false
  //isDatetime: false
  agreementAction: PropertyMeta<AgreementActionMetaI>;
}>;

export var PersonAgreeActionDTOMeta: PersonAgreeActionDTOMetaI =
  {} as PersonAgreeActionDTOMetaI;
PersonAgreeActionDTOMeta = typeMeta("PersonAgreeActionDTO", {
  agreementId: propertyMeta(
    "agreementId",
    false,
    false,
    false,
    AgreementRefMeta,
  ),
  agreementAction: propertyMeta(
    "agreementAction",
    false,
    false,
    false,
    AgreementActionMeta,
  ),
});

const metaI = PersonAgreeActionDTOMeta;

registerMeta(() => {});

export class PersonAgreeActionDTOTracked implements PersonAgreeActionDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  agreementId__I?: AgreementRefTracked = undefined;
  agreementIdIsSet: boolean = false;
  set agreementId(v: undefined | AgreementRefTracked) {
    if (v !== undefined) {
      this.agreementId__I = v;
      this.agreementIdIsSet = true;
    } else {
      this.agreementId__I = v || undefined;
      this.agreementIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementId() {
    return this.agreementId__I;
  }
  agreementAction__I?: AgreementAction = undefined;
  agreementActionIsSet: boolean = false;
  set agreementAction(v: undefined | AgreementAction) {
    if (v !== undefined) {
      this.agreementAction__I = v;
      this.agreementActionIsSet = true;
    } else {
      this.agreementAction__I = v || undefined;
      this.agreementActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAction() {
    return this.agreementAction__I;
  }
  constructor(config?: PersonAgreeActionDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.agreementId?.setIds();
  }
  assignFrom(
    config: PersonAgreeActionDTOOptional,
    options?: AssignOptions,
  ): PersonAgreeActionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.agreementId &&
      this.agreementIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementId = new AgreementRefTracked(config.agreementId, options);
      if (optionsRequired.unassign) this.agreementIdIsSet = false;
      else this.agreementIdIsSet = true;
    }
    if (
      config.agreementAction &&
      this.agreementActionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAction = config.agreementAction;
      if (optionsRequired.unassign) this.agreementActionIsSet = false;
      else this.agreementActionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreeActionDTOTrackedI {
    const cloned = {} as PersonAgreeActionDTOTrackedI;
    if (
      this.agreementIdIsSetDeep() &&
      this.agreementIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementIdIsSet = true;
      cloned.agreementId = this.agreementId?.removeUnset(filter);
    } else {
      //cloned.agreementIdIsSet = false
    }
    if (
      this.agreementActionIsSetDeep() &&
      this.agreementActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementActionIsSet = true;
      cloned.agreementAction = this.agreementAction;
    } else {
      //cloned.agreementActionIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreeActionDTOTrackedI {
    if (!this.agreementIdApplyFilter(filter)) this.agreementIdIsSet = false;
    this.agreementId?.unassignAll(filter);

    if (!this.agreementActionApplyFilter(filter))
      this.agreementActionIsSet = false;

    return this;
  }
  agreementIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreeActionDTOMeta.agreementId,
      PersonAgreeActionDTOMeta,
      this.agreementId,
      this,
    );
  }
  agreementIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementIdIsSet && this.agreementIdApplyFilter(filter))
      return true;
    return this.agreementId?.anySet(filter) == true;

    return false;
  }
  agreementActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreeActionDTOMeta.agreementAction,
      PersonAgreeActionDTOMeta,
      this.agreementAction,
      this,
    );
  }
  agreementActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementActionIsSet && this.agreementActionApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.agreementIdIsSetDeep(filter)) return true;
    if (this.agreementActionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
